import { ActionsUnion, createAction } from 'spw-redux/types';
import {
  IProjectSpaceType,
  SpaceTypeColor,
} from 'spw-redux/modules/space_types/types';

export const FETCH_PROJECT_SPACE_TYPES = 'spaceTypes/FETCH_PROJECT_SPACE_TYPES';
export const FETCH_PROJECT_SPACE_TYPES_SUCCESS =
  'spaceTypes/FETCH_PROJECT_SPACE_TYPES_SUCCESS';
export const SET_CURRENT_SPACE_TYPE_COLORS =
  'spaceTypes/SET_CURRENT_SPACE_TYPE_COLORS';
export const TOGGLE_CLIENT_FACING_NAMES_ARE_VISIBLE =
  'spaceTypes/TOGGLE_CLIENT_FACING_NAMES_ARE_VISIBLE';
export const UPDATE_PROJECT_SPACE_TYPE = 'spaceTypes/UPDATE_PROJECT_SPACE_TYPE';
export const BULK_UPDATE_PROJECT_SPACE_TYPES =
  'spaceTypes/BULK_UPDATE_PROJECT_SPACE_TYPES';
export const UPDATE_PROJECT_SPACE_TYPE_POSITION =
  'spaceTypes/UPDATE_PROJECT_SPACE_TYPE_POSITION';
export const REASSIGN_PROJECT_SPACE_TYPE =
  'spaceTypes/REASSIGN_PROJECT_SPACE_TYPE';

export const fetchProjectSpaceTypes = () =>
  createAction(FETCH_PROJECT_SPACE_TYPES);
export const fetchProjectSpaceTypesSuccess = (
  projectSpaceTypes: IProjectSpaceType[]
) => createAction(FETCH_PROJECT_SPACE_TYPES_SUCCESS, { projectSpaceTypes });
export const setCurrentSpaceTypeColors = (currentSpaceTypeColors: {
  [index: string]: SpaceTypeColor;
}) => createAction(SET_CURRENT_SPACE_TYPE_COLORS, { currentSpaceTypeColors });

export const toggleClientFacingNamesAreVisible = () =>
  createAction(TOGGLE_CLIENT_FACING_NAMES_ARE_VISIBLE);

export const updateProjectSpaceType = (payload: {
  categoryId?: number;
  projectSpaceTypeId: number;
  spaceTypeId?: number;
  icon?: string | null;
  clientFacingName?: string;
}) => createAction(UPDATE_PROJECT_SPACE_TYPE, payload);

export const updateProjectSpaceTypePosition = (
  projectSpaceTypeId: number,
  previousId?: number
) =>
  createAction(UPDATE_PROJECT_SPACE_TYPE_POSITION, {
    projectSpaceTypeId,
    previousId,
  });

export const bulkUpdateProjectSpaceTypes = (
  projectSpaceTypes: IProjectSpaceType[]
) => createAction(BULK_UPDATE_PROJECT_SPACE_TYPES, { projectSpaceTypes });

export const reassignProjectSpaceType = (
  projectSpaceTypeId: number,
  categoryId: number
) =>
  createAction(REASSIGN_PROJECT_SPACE_TYPE, { projectSpaceTypeId, categoryId });

export const actions = {
  fetchProjectSpaceTypes,
  fetchProjectSpaceTypesSuccess,
  setCurrentSpaceTypeColors,
  toggleClientFacingNamesAreVisible,
  updateProjectSpaceType,
  updateProjectSpaceTypePosition,
  bulkUpdateProjectSpaceTypes,
  reassignProjectSpaceType,
};

export type Actions = ActionsUnion<typeof actions>;
